import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {map, shareReplay} from 'rxjs/operators';

import {TerraUtils} from 'src/app/shared/TerraUtils';
import HoldingDiscriminator from 'src/app/shared/enums/HoldingDiscriminator.enum';
import HoldingStatus from 'src/app/shared/enums/HoldingStatus.enum';
import HoldingType from 'src/app/shared/enums/HoldingType.enum';
import InvestmentType from 'src/app/shared/enums/InvestmentType.enum';
import {AnalyticsServiceNameModel, TelemetryService} from 'telemetry-library';
import InvestmentSecurityType from '../../../shared/enums/InvestmentSecurityType.enum';
import {LpPaymentRequestService} from '../../lp-top-notification/lp-payment-request.service';
import {LpHoldingPositionRes} from '../../models/LpHoldingPositionRes.model';

@Component({
  selector: 'terra-lp-holding-card',
  templateUrl: './lp-holding-card.component.html',
  styleUrls: ['./lp-holding-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpHoldingCardComponent implements OnInit {
  #holding: any;
  @Input() holding: any;
  @Input() isOpportunity: boolean = false;

  EXAMPLE_ASSET_ID = TerraUtils.consts.EXAMPLE_ASSET_ID;
  shouldInterpolateLocation: boolean;

  backgroundImageUrl: string;
  hasActiveCapitalCall$ = this.lpPaymentRequestService.pendingPaymentRequests$.pipe(
    shareReplay(1),
    map(prs => prs.some(pr => pr.holdingId === this.holding.id))
  );

  HoldingStatus = HoldingStatus;
  HoldingType = HoldingType;
  InvestmentSecurityType = InvestmentSecurityType;
  InvestmentType = InvestmentType;

  constructor(
    private lpPaymentRequestService: LpPaymentRequestService,
    private telemetryService: TelemetryService
  ) {
  }

  reportPageViewEvent(): void {
    this.telemetryService.create({
      eventID: '1018',
      eventTitle: 'LP OPPORTUNITY - IMPRESSION',
      holdingID: this.holding.id,
    }, AnalyticsServiceNameModel.Mixpanel);
  }

  ngOnInit() {
    this.setBackgroundImageUrl();
    this.shouldInterpolateLocation = !(typeof this.holding.location === 'string')
    //this.reportPageViewEvent();
  }

  private setBackgroundImageUrl() {
    this.backgroundImageUrl = this.holding.attachments?.[0]?.metaFileLink?.url || this.holding.photo || `assets/images/photo-carousel-empty.png`;
  }

  reportHoldingClickedEvent(): void {
    this.telemetryService.create({
      eventID: '1018',
      eventTitle: 'LP OPPORTUNITY - IMPRESSION',
      holdingID: this.holding.id,
    }, AnalyticsServiceNameModel.Mixpanel);
  }

  get position(): LpHoldingPositionRes {
    return LpHoldingPositionRes.aggregate(this.holding?.position);
  }

  get isAsset(): boolean {
    return (typeof this.holding.discriminator === 'string' ? HoldingDiscriminator.parse(this.holding.discriminator) : this.holding.discriminator) === HoldingDiscriminator.Asset;
  }

  get isFund(): boolean {
    return (typeof this.holding.discriminator === 'string' ? HoldingDiscriminator.parse(this.holding.discriminator) : this.holding.discriminator) === HoldingDiscriminator.Fund;
  }

  get holdingType(): string {
    return this.isAsset ? 'ASSET' : 'FUND';
  }

  get totalInvestedLabel(): string {
    if ('initialSecurityType' in this.holding) {
      return this.holding.initialSecurityType === InvestmentSecurityType.Debt ? 'Invested Amount' : 'Equity Invested';
    }

    return 'Equity Invested';
  }
}
